module.exports = __webpack_public_path__ + "static/media/29ADMSPC11.3b7e3b9d.jpg";